// tslint:disable: max-line-length
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import './styles.scss';
import { getItem, removeItem, setItem } from '../../utils/localStorage';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { getAvailableTemplate } from '../../components/SelfAssessmentAssignDepartment/apiCaller';
import { getAssessmentSeries, sendSelfAssessment } from './apiCaller';
import {
  showErrorMessage,
  showSuccessMessage,
} from '../../helpers/showMessage';
import { getSelfAssessment } from '../SelfAssessments/apiCaller';
import AssessmentSeries from './AssessmentSeries';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { SelfAssessmentSummaryAPIViewScreen } from './../../requests/assessements';
import { sortBy } from 'lodash';
import { isUnauthorized } from '../../utils/common';
import { ButtonLarge } from '../../app/common/sharedComponents/buttons/ButtonLarge';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import { sentryReport } from '../../helpers/sentry';

const ViewSelfAssessmentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  align-items: center;
  width: 100%;
`;

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 100px);
  background-color: #fff;
  width: 97%;
  top: 65px;
  position: absolute;
  margin-top: 15px;
  padding-bottom: 85px;
  padding-left: 10px;
  padding-right: 10px;
`;
const ViewSelfAssessment = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const loc: any = { ...location };

  const {
    assessmentData,
    assessment,
    evnt,
    isListScreen,
    isSendScreen,
    templateId,
  } = loc.state;
  const [assessmentSeries, setAssesmentSeries] = useState<any>([]);
  const [summaryData, setSummaryData] = useState<any>([]);
  const [disabledCategories, setdisabledCategories] = useState<any>([]);
  const [parentInfo, setParentInfo] = useState(false);
  const [availableTemplateIds, setAvailableTemplateIds] = useState<number[]>();
  const viewSelfAssessmentDetailHandler = () => {
    loc.state.categoriesData.map((o) => {
      disabledCategories.push(o.id);
      disabledCategories.push(o.sourceTemplateCategoryId);
      o.subCategories.map((k) => {
        disabledCategories.push(k.id);
        disabledCategories.push(k.sourceTemplateCategoryId);
      });
      o.superCategories.map((k) => {
        disabledCategories.push(k.id);
        disabledCategories.push(k.sourceTemplateCategoryId);
      });
    });
    if (parentInfo) {
      const selectedHotel = getItem('selectedHotel');
      const selectedBrand = getItem('selectedBrand');
      setItem('parentAssessment', {
        brandId: selectedBrand,
        hotelId: selectedHotel,
        subject: assessmentData.proofReaderNotes,
        notes: assessmentData.adminNotes,
        assigneeId: assessmentData.auditor.id,
        stayEnd: assessmentData.stayEnd,
        categories: disabledCategories,
      });
      setItem('selfAssessments', [
        {
          brandId: selectedBrand,
          hotelId: selectedHotel,
          subject: assessmentData.proofReaderNotes,
          notes: assessmentData.adminNotes,
          assigneeId: assessmentData.auditor.id,
          stayEnd: assessmentData.stayEnd,
          categories: disabledCategories,
        },
      ]);
      setItem('disabledCategories', disabledCategories);
      setItem('selfAssessmentslocal', [
        {
          brandId: selectedBrand,
          hotelId: selectedHotel,
          subject: assessmentData.proofReaderNotes,
          notes: assessmentData.adminNotes,
          assigneeId: assessmentData.auditor.id,
          stayEnd: assessmentData.stayEnd,
          categories: disabledCategories,
        },
      ]);
      navigate('/selfAssessment/selectDepartments', {
        state: { disabledCategories, parentId: assessmentData.id },
      });
    } else {
      removeItem('parentAssessment');
      removeItem('selfAssessments');
      setItem('disabledCategories', disabledCategories);
      removeItem('selfAssessmentslocal');
      navigate('/selfAssessment/selectDepartments', {
        state: { disabledCategories, parentId: assessmentData.id },
      });
    }
  };

  const showAddDepartmentButton = () => {
    return (
      availableTemplateIds &&
      availableTemplateIds.includes(templateId) &&
      isListScreen &&
      evnt === 'sent'
    );
  };

  useEffect(() => {
    getAvailableTemplate()
      .then((templates) => {
        setAvailableTemplateIds(templates.map((template) => template.id));
      })
      .catch((error) => {
        sentryReport(error.response.data, error.message, error.code, {
          summaryError: t(
            'COMMON.ALERT_MESSAGES.UNABLE_TO_GET_LIST_OF_AVAILABLE_TEMPLATES'
          ),
          path: '/viewSelfAssessment',
        });
        showErrorMessage(
          t('COMMON.ALERT_MESSAGES.UNABLE_TO_GET_LIST_OF_AVAILABLE_TEMPLATES')
        );
      });

    if (assessmentData.id) {
      const percentageData = {};
      if (
        assessment &&
        assessment.duplicateCategories &&
        assessment.duplicateCategories.length
      ) {
        assessment.duplicateCategories.forEach(
          (obj) => (percentageData[obj.templateCategoryId] = obj.percentage)
        );
      }
      getAssessmentSeries(assessmentData.id)
        .then((response) => {
          if (response && response.results && response.results.length) {
            const FilterData = [...response.results];
            FilterData.map((obj) => {
              obj.duplicateCategories.map((dupcat) => {
                dupcat.percentage = percentageData[dupcat.templateCategoryId];
                return dupcat;
              });
              return obj;
            });
            setAssesmentSeries(sortBy(FilterData, 'id'));
          } else {
            if (isSendScreen) {
              getSelfAssessment(assessmentData.id)
                .then((selfAssessmentResponse) => {
                  if (selfAssessmentResponse) {
                    assessmentData.duplicateCategories =
                      selfAssessmentResponse.duplicateCategories;
                    setAssesmentSeries([assessmentData]);
                  }
                })
                .catch(() => {
                  'Unable to get self assessment';
                });
            } else {
              assessmentData.duplicateCategories =
                assessment.duplicateCategories;
              setAssesmentSeries([assessmentData]);
              setParentInfo(true);
              setItem('missingDepartment', 1);
            }
          }
        })
        .catch((error) => {
          showErrorMessage('Unable to get assessment', !isUnauthorized(error));
        });
    } else {
      setAssesmentSeries([assessmentData]);
    }
  }, []);

  useEffect(() => {
    if (assessmentSeries && assessmentSeries.length > 0) {
      SelfAssessmentSummaryAPIViewScreen(assessmentData.id, 'LQA')
        .then((res) => {
          setSummaryData(res);
        })
        .catch((err) => {
          showErrorMessage(
            'Unable to get assessment summary',
            !isUnauthorized(err)
          );
        });
    }
  }, [assessmentSeries]);

  const handleSendAssessment = (Ids) => {
    sendSelfAssessment(Ids)
      .then((response) => {
        if (response) {
          showSuccessMessage('Self Assessment send successfully');
          navigate('/myactions');
        }
      })
      .catch((err) => showErrorMessage('Unable to send assessment'));
  };

  return (
    <ViewSelfAssessmentContainer>
      <div className="header">
        <AppHeader title={t('COMMON.SELF_ASSESSMENT.TITLES.SELF_ASSESSMENT')} />
      </div>
      {!assessmentSeries || assessmentSeries.length <= 0 || !summaryData ? (
        <LoadingContent />
      ) : (
        <ContentArea>
          <div className="assesementDate">
            Created: {moment(assessmentData.stayStart).format('DD MMM YY')}
          </div>
          {assessmentSeries &&
            assessmentSeries.length &&
            assessmentSeries.map((o, i) => (
              <AssessmentSeries
                key={i}
                assessmentData={o}
                summary={
                  summaryData &&
                  summaryData.filter((k) => k.assessmentId === o.id)
                }
                templateId={templateId}
              />
            ))}
          <div className="btnContainer">
            {showAddDepartmentButton() && (
              <ButtonLarge
                title={t(
                  'COMMON.SELF_ASSESSMENT.BUTTON.ASSIGN_NEW_DEPARTMENTS'
                )}
                onClick={() => {
                  viewSelfAssessmentDetailHandler();
                }}
                disabled={!assessmentData.hasChild}
              />
            )}
            {isSendScreen && (
              <ButtonLarge
                title={t('COMMON.SELF_ASSESSMENT.BUTTON.SEND_SELF_ASSESSMENT')}
                onClick={() => {
                  if (assessmentSeries && assessmentSeries.length) {
                    handleSendAssessment(assessmentSeries.map((o) => o.id));
                  }
                }}
              />
            )}
            {isListScreen && (
              <ButtonLarge
                inverted={true}
                outlined={true}
                title={t('COMMON.SELF_ASSESSMENT.BUTTON.BACK')}
                onClick={() => navigate(-1)}
              />
            )}
          </div>
        </ContentArea>
      )}
    </ViewSelfAssessmentContainer>
  );
};

export default ViewSelfAssessment;
